import React from 'react'
import Control from './control'

const Controller = () => {
    return (
        <Control />
    )
}

export default Controller